import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect, useState } from 'react';
import useResizeObserver from 'use-resize-observer'; // useResizeObserver is now available in usehooks-ts@2.13.0

// Used to track video element size as it gets mounted and/or resized.
// This size will be used to create a matching sized canvas to copy the
// video image over when captured.
const useSize = target => {
  const $ = _c(7);
  const [size, setSize] = useState();
  let t0;
  if ($[0] !== target.current) {
    t0 = () => {
      if (!target?.current) {
        return;
      }
      const {
        width,
        height
      } = target.current.getBoundingClientRect();
      if (width && height) {
        setSize({
          width,
          height
        });
      }
    };
    $[0] = target.current;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== target) {
    t1 = [target];
    $[2] = target;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  useLayoutEffect(t0, t1);
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = t3 => {
      const {
        width: width_0,
        height: height_0
      } = t3;
      if (width_0 && height_0) {
        setSize({
          width: width_0,
          height: height_0
        });
      }
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== target.current) {
    t3 = {
      ref: target.current,
      onResize: t2
    };
    $[5] = target.current;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useResizeObserver(t3);
  return size;
};
export default useSize;